<!-- 自动化三级页面 -->
<template>
  <div class="home animate__animated animate__fadeIn">
    <div class="top">
      <Header />
    </div>
    <div class="banner">
      <!-- <img :src="imgUrl" alt=""> -->
      <div class="animate__animated animate__fadeInUp animate__faster">
        <span style="margin-bottom:20px">自动化</span>
        <span>尖端的技术，灵活的产品，丰富的经验，</span>
        <span>帮助企业走向可持续发展的未来</span>
      </div>
    </div>
    <div class="main">
      <div class="main_center">
        <div class="bread">
          <!-- <span style="cursor:pointer" @click="handleHome">首页</span>> -->
          <span @click="handleJiejue" style="cursor:pointer">解决方案</span>> 自动化
        </div>
        <div class="title">实时掌控业务的过程</div>
        <div class="text">
          <span>
            工业自动化技术快速发展，需要工厂基层的设备与企业的其余部分形成更紧密地集成。这种集成需要安全的网络基础设施、智能设备来实现有效的数据采集，还需要能够将数据转变为可操作的信息。
          </span>
          <span>我们以技术为先导，通过对核心部件的创新组合，为客户提供切实可行的自动化工厂解决方案。通过企业的控制和信息集成，我们的客户将工厂、现场、设施和人员连接起来，从而优化其运营我们从工厂的设备、网络和平台的组合方面入手，帮助工厂构建最有效的工业自动化系统，从而满足客户的特定需求。</span>
        </div>
        <ul>
          <li
            v-for="(item,index) in imgList"
            :key="index"
            v-bind:style="{ 'background-image': 'url(' + item.url+ ')'}"
          >
            <!-- <div class="image" >
            <div class="image" v-bind:style="{ 'background-image': 'url(' + item.url+ ')','background-repeat':'no-repeat','background-size':'cover' }">
              <img :src="item.url" alt />
            </div>-->
            <div class="introduce">
              <span class="theme">{{item.theme}}</span>
              <span class="content" v-html="item.content">{{item.content}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@components/header";
import Footer from "@components/footer";
export default {
  name: "Automation",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      headerList: [
        { name: "解决方案" },
        { name: "产品中心" },
        { name: "咨询服务" },
        { name: "专长" },
        { name: "了解我们" },
        { name: "加入我们" },
      ],
      jieList: [
        { name: "自动化", link: "" },
        { name: "物联", link: "" },
        { name: "能源", link: "" },
        { name: "环境", link: "" },
      ],
      chanList: [
        {
          name: "工业无线",
          detail: [
            { name: "无线网络", link: "" },
            { name: "无线通讯", link: "" },
            { name: "无线位置", link: "" },
            { name: "无限分析", link: "" },
          ],
        },
        {
          name: "工业软件",
          detail: [
            { name: "能源管理软件", link: "" },
            { name: "大数据平台", link: "" },
            { name: "GIS地图信息平台", link: "" },
          ],
        },
        {
          name: "测量仪表",
          detail: [
            { name: "流体仪表", link: "" },
            { name: "电力仪表", link: "" },
            { name: "压力仪表", link: "" },
            { name: "温度仪表", link: "" },
            { name: "液位仪表", link: "" },
          ],
        },
      ],
      ziList: [
        {
          name: "咨询",
          detail: [
            { name: "智能工厂设计咨询", link: "" },
            { name: "工业物联园区设计咨询", link: "" },
          ],
        },
        {
          name: "服务",
          detail: [
            { name: "设备安装与运维服务", link: "" },
            { name: "数据分析与校准服务", link: "" },
            { name: "能源与能效诊断服务", link: "" },
          ],
        },
      ],
      zhuanList: [
        { name: "跨学科研发", link: "" },
        { name: "物联", link: "" },
        { name: "工业无线", link: "" },
        { name: "流体测量", link: "" },
      ],
      liaoList: [
        { name: "企业概述", link: "" },
        { name: "企业文化", link: "" },
        { name: "荣誉资质", link: "" },
        { name: "新闻报告", link: "" },
        { name: "合作伙伴", link: "" },
      ],
      jiaList: [
        { name: "社会招聘", link: "" },
        { name: "校园招聘", link: "" },
      ],
      headerFlag: true,
      img1before: require("@assets/img/logob.png"),
      img2before: require("@assets/img/soub.png"),
      img3before: require("@assets/img/daob.png"),
      activeIndex: -1,
      modalFlag: false,
      rotate: false, //控制互转效果
      erweima: require("@assets/img/erma.png"),
      //   banner: require("@assets/img/banner2.jpg"),
      imgList: [
        {
          theme: "工业自动化产品创新组合",
          content:
            "基于现代工业变革，企业都在积极构建物联网工厂，因此需要一个自动化系统，其中所有设备都应无缝集成，而不是一系列单独的产品。我们对自身的产品、软件和服务进行了系列革新，帮助客户打破设备级系统与企业系统之间的隔阂，从而提高决策能力。<br/>我们提供面向未来的创新型解决方案，它们基于现代技术构建，可帮助客户打造实时、安全的基础设施，从而交付最具影响力的结果。",
          url: require("../../assets/img/zdh1.png"),
        },
        {
          theme: "安全的网络系统架构",
          content:
            "客户需要进改进运营中的信息共享内容和方式。接收和使用实时信息有助于提高企业的生产效率。借助工业无线网络的搭建，工厂和企业能够安全可靠地互联。我们采用了一种全方位开放式系统来安全地连接工厂和企业。我们的产品、解决方案和专业服务可帮助客户打造安全的网络基础设施、工业信息安全、自动化和信息解决方案。",
          url: require("../../assets/img/zdh2.png"),
        },
        {
          theme: "计算信息的多样化应用",
          content:
            "我们将计算功能集成到工厂大量设备中，客户可以从机器和设备中获得更多有价值的信息，不但加强设备的监控管理，还对企业决策提供重要参考依据。",
          url: require("../../assets/img/zdh3.png"),
        },
      ],
      spanFlag: true,
      imgUrl: require("../../assets/img/zidong.png"), // 背景图片地址
    };
  },
  methods: {
    handleToHome() {
      //点击图片跳转到首页
      this.$router.push("/");
      // console.log(123);
    },
    enter: function () {
      this.headerFlag = false;
      this.img1before = require("@assets/img/logob.png");
      this.img2before = require("@assets/img/soub.png");
      this.img3before = require("@assets/img/daob.png");
      this.activeIndex = -1;
    },
    leave: function () {
      this.headerFlag = true;
      this.img1before = require("@assets/img/logob.png");
      this.img2before = require("@assets/img/soub.png");
      this.img3before = require("@assets/img/daob.png");
      this.activeIndex = -1;
    },
    selected(index) {
      this.activeIndex = index;
      // console.log(this.activeIndex);
    },
    navShow() {
      // console.log(index);
    },
    navNone() {
      // console.log(index);
    },
    afterLoad() {},
    showAll() {
      //打开弹窗
      //点击右上角三条横杠
      this.modalFlag = true;
      // var mo=function(e){e.preventDefault();};
      //   document.body.style.overflow='hidden';
      //   document.addEventListener("touchmove",mo,false);//禁止页面滑动
      // this.$refs.fullpage.api.setAllowScrolling(false, "up,down,left, right");
    },
    handleClose() {
      //关闭弹窗
      this.modalFlag = false;
      // this.$refs.fullpage.api.setAllowScrolling(true, "up,down,left, right");
    },
    zhuan() {
      //旋转模态框叉号
      this.rotate = !this.rotate;
    },
    // 面包屑
    handleHome() {
      this.$router.push("/");
    },
    handleEnter(index) {
      //滑上组件时字体消失 遮罩显示
      // this.spanFlag=false;
      // console.log(index)
      this.imgList[index].spanFlag = false;
      this.imgList[index].maskFlag = true;
    },
    handleLeave(index) {
      // console.log(index)
      this.imgList[index].spanFlag = true;
      this.imgList[index].maskFlag = false;
    },
    //跳往解决方案二级页面
    handleJiejue() {
      this.$router.push("/solution");
    }, // 显示回到顶部按钮
  },
};
</script>

<style lang='scss' scoped>
.home {
  width: 100%;
  height: 100%;
  position: relative;
}
.top {
  // position: sticky !important;
  // top:0;
  // z-index: 100;
}
.banner {
  width: 100%;
  height: 500px;
  background: url("../../assets/img/zidong.png") no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: bottom center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  position: relative;
  div {
    width: 75%;
    margin: 0 auto;
  }
  img {
    width: 100%;
    // height: 500px;
    position: absolute;
    bottom: 0;
    // left: 0;
    // bottom: 0;
    // right: 0;
  }
  span {
    font-size: 26px;
    font-family: YaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    display: block;
  line-height: 44px;
    letter-spacing: 2px;
    // margin-left: 20%;
    &:nth-child(1) {
      font-size: 48px;
      font-family: YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      letter-spacing: 4px;
      // padding-top: 15%;
      // padding-bottom: 18px;
    }
  }
}
.main {
  width: 100%;
  background: #f5f5f5;
  .main_center {
    width: 75%;
    // height: 100%;
    margin: 0 auto;
    .bread {
      padding-top: 30px;
      font-size: 16px;
      font-family: YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      cursor: default;
    }
    .title {
      font-size: 48px;
      font-family: YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      padding-top: 104px;
    }
    .text {
      // width: 72%;
      margin: 0 auto;
      font-size: 24px;
      line-height: 44px;
      font-family: YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      padding-top: 33px;
      text-align: center;
      span {
        display: block;
        &:nth-child(1) {
          margin-bottom: 50px;
        }
      }
    }
    ul {
      width: 100%;
      padding-top: 82px;
      text-align: left;
      padding-bottom: 105px;
      li {
        min-height: 310px;
        width: 100%;
        display: flex;
        // background: pink;
        padding-top: 1%;
        padding-bottom: 1%;
        background-size: 50% 100%;
        background-repeat: no-repeat;
        background-position: left center;
        &:nth-child(2n) {
          background-position: right center !important;
          .introduce {
            margin: 0;
          }
        }
        // justify-content:end;
        // align-items: center;
        // position: relative;
        // height: 307px;
        // padding-bottom: 20px;
        margin-bottom: 80px;
        // &:nth-child(2) {
        //   .image {
        //     right: 0;
        //   }
        //   .introduce {
        //     left: 0;
        //   }
        // }
        .image {
          width: 50%;
          height: 100%;
          overflow: hidden;
          // position: absolute;
          transition: all 0.6s !important;
          // // background: url("../../assets/img/banner1.jpg") no-repeat;
          // background-size: cover;
          // -webkit-background-size: cover;
          // -o-background-size: cover;
          // background-position: center bottom;
          // &:nth-child(1){
          //    background: url("../../assets/img/banner1.jpg") no-repeat;
          // }
          // &:nth-child(2){
          //    background: url("../../assets/img/banner2.jpg") no-repeat;
          // }
          // &:nth-child(3){
          //    background: url("../../assets/img/banner3.jpg") no-repeat;
          // }
          img {
            width: 100%;
          }
          &:hover {
            transform: scale(1.1);
          }
        }
        .introduce {
          // float: right;
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 52%;
          min-height: 80%;
          background: rgba(255, 255, 255, 1);
          box-sizing: border-box;
          text-align: left;
          padding: 29px 33px 31px 40px;
          margin-left: 48%;
          // position: absolute;
          // right: 0;
          // top: 10%;
          .theme {
            display: block;
            font-size: 30px;
            font-family: Source Han Sans SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 23px;
          }
          .content {
            font-size: 17px;
            font-family: Source Han Sans SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            line-height: 29px;
          }
        }
      }
    }
  }
}
</style>
